import { IkasBaseModel } from "../../base";
import {
  IkasCampaignOffer,
  IkasCampaignOfferTargetPageType,
} from "../../campaign-offer";

export type IkasCartCampaignOffer = {
  appliedOrderLineId: string | null;
  campaignOfferId: string;
  campaignOffer: IkasCampaignOffer | null;
  campaignOfferProductId: string | null;
  offerEndDate: number | null;
  offerStartDate: number;
  status: IkasCartCampaignOfferStatus;
  targetPageTypes: IkasCampaignOfferTargetPageType[];
  triggerSourceOrderLineId: string;
} & IkasBaseModel;

export enum IkasCartCampaignOfferStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REMOVED = "REMOVED",
  WAITING_FOR_ACTION = "WAITING_FOR_ACTION",
}
